import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import { SET_LAST_CONTACT_LOCATION, LastContactLocation } from '../actions';

const reducer: Reducer<string, LastContactLocation> = (
  state = null,
  action
) => {
  switch (action.type) {
    case SET_LAST_CONTACT_LOCATION: {
      return action.contactLocation;
    }
    case CLEAR_PRIO_CACHE: {
      return null;
    }
    default:
      return state;
  }
};

export const getLastContactsLocation = (state: string) => state;

export default reducer;